import React, { useContext, useEffect, useState } from 'react'
import { Modal, Tree, Button, message } from 'antd'
import { ExclamationCircleFilled, AppstoreOutlined, RightOutlined } from '@ant-design/icons'
import { mapTree } from '../../../../../../utils'
import ImgList from './components/imgList'
// import { getImgZoneSort } from 'SERVICES/activity'
import { TableContext } from '../../../../../../'
import './index.less'

interface Props {
  width: number
  height: number
  size: number
  imgExtension: string
  visible: boolean
  setVisible: any
  onChange: any
}

const ImgZone = (props: Props) => {
  const { width, height, size, imgExtension, visible = false, setVisible, onChange } = props

  const [treeData, setTreeData] = useState([])
  const [value, setValue] = useState('')
  const [selectedKeys, setSelectedKeys] = useState([0])
  const { getImgZoneSort } = useContext(TableContext)

  useEffect(() => {
    if (visible) {
      getImgZoneSort(0).then((res) => {
        if (res.success) {
          setTreeData(mapTree(res.data.children))
        }
      })
    }
  }, [visible])

  const rendnerTitle = () => {
    return (
      <div className="img-zone-title">
        <div className="left-title">图片空间</div>
        <div className="title-tip">
          <ExclamationCircleFilled style={{ marginLeft: 16 }} /> 图片要求：只显示尺寸为{width}X{height}、单张图片小于
          {size / 1024}M，格式为
          {imgExtension}的图片。
        </div>
      </div>
    )
  }

  const onSelect = (selectedKeys: React.Key[], info: any) => {
    if (selectedKeys && selectedKeys.length) {
      setSelectedKeys(selectedKeys)
    }
  }

  const onChangeVal = (e) => {
    setValue(e)
  }

  const renderFooter = () => {
    return (
      <div className="img-zone-footer">
        <Button onClick={() => window.open('//imgzone.shop.jd.com/')}>
          进入图片空间
          <RightOutlined style={{ marginLeft: 8, color: 'rgba(0, 0, 0, 0.65)' }} />
        </Button>
        <div>
          <Button
            type="primary"
            style={{ borderRadius: 20 }}
            onClick={() => {
              if (!value) {
                return message.error('请选择图片')
              }
              window.log('shop_zhuti', 'picture_space', '图片空间上传按钮')
              onChange(value)
              setVisible(false)
            }}
          >
            确认
          </Button>
          <Button style={{ borderRadius: 20 }} onClick={() => setVisible(false)}>
            取消
          </Button>
        </div>
      </div>
    )
  }

  return (
    <Modal
      width={'81vw'}
      visible={visible}
      title={rendnerTitle()}
      className="img-zone"
      destroyOnClose
      bodyStyle={{ padding: 0 }}
      footer={renderFooter()}
      onCancel={() => setVisible(false)}
    >
      {visible && (
        <div className="img-zone-container">
          <div className="img-zone-left">
            <div
              className={selectedKeys[0] === 0 ? 'active left-title' : 'left-title'}
              onClick={() => setSelectedKeys([0])}
            >
              <AppstoreOutlined style={{ marginRight: 6 }} />
              全部分类
            </div>
            <div style={{ height: 521, overflow: 'auto' }}>
              <Tree blockNode onSelect={onSelect} treeData={treeData} selectedKeys={selectedKeys} />
            </div>
          </div>
          <div className="img-zone-right">
            <ImgList
              selectedKeys={selectedKeys}
              onChange={onChangeVal}
              imgData={{
                imgExtension: imgExtension.toLocaleUpperCase(),
                size,
                width,
                height,
              }}
            />
          </div>
        </div>
      )}
    </Modal>
  )
}

export default ImgZone
